import {RelayPaginationState} from "../../pagination";
import {SortBy} from "../../../common";
import {AnticipatedDischargeModalState} from "./ConfirmedDischargeDateModal";
import {tryFormatLocalDate} from "common/util/date";
import {ClientProfile, ParentCaseInfo} from "../domain";

export type AnticipatedDischargeInfo = {
    idx: number;
    guid: string;
    sfId: string;
    anticipatedDischargeDate: string;
    dischargeNotificationDueDate: string;
    providerConfirmedDischargeDate: string;
    clinicalRationale: string;
    client: ClientProfile;
    parentCase: ParentCaseInfo;
}

export type AnticipatedDischargesFilterValue = {
    clientName: string;
    anticipatedDischargeDateFrom: Date | null;
    anticipatedDischargeDateTo: Date | null;
    dischargeNotificationDateFrom: Date | null;
    dischargeNotificationDateTo: Date | null;
    status: "" | "Open" | "Confirmed";
}

export type AnticipatedDischargesPageState = {
    pagination: RelayPaginationState;
    filter: AnticipatedDischargesFilterValue;
    pageSize: number;
    search: string;
    sortBy: SortBy<AnticipatedDischargeInfo>;
    selectedUnconfirmedADs: AnticipatedDischargeInfo[];
    dischargeModalState: AnticipatedDischargeModalState;
    dischargeModalSelectedItems: AnticipatedDischargeInfo[];
}

export function asQueryParam(filter: AnticipatedDischargesFilterValue) {
    return {
        status: filter.status,
        anticipatedDischargeDateFrom: tryFormatLocalDate(filter.anticipatedDischargeDateFrom ?? null),
        anticipatedDischargeDateTo: tryFormatLocalDate(filter.anticipatedDischargeDateTo ?? null),
        dischargeNotificationDueDateFrom: tryFormatLocalDate(filter.dischargeNotificationDateFrom ?? null),
        dischargeNotificationDueDateTo: tryFormatLocalDate(filter.dischargeNotificationDateTo ?? null),
    };
}

